import React, { useCallback } from "react";
import { DetailedAlert } from "../../../components/DetailedAlert";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { ImportModal } from "../../components/ImportModal";

export const ImportPortalCodeGroupsModal = ({ portalId, onImport, ...rest }) => {
  const handleImport = useCallback(
    async (values) => {
      const params = {
        benefitManagementPortalId: portalId,
        file: {
          bytes: values.file,
        },
      };

      const res = await api.post("/admin/benefit_management_portal_code_groups/import.json", snakifyKeys(params));

      onImport?.(res.data?.meta?.message, res.data?.meta?.error_details);
    },
    [onImport, portalId]
  );

  const details = [
    <ul key="import-info">
      <li>
        <b>Imports are add-only:</b> they will not remove code groups already associated with this portal.
      </li>
      <li>
        CSV may include either <code>code_group_name</code> or <code>code_group_id</code>.
      </li>
    </ul>,
  ];

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title="Import Code Groups..."
      exampleDownloadPath="/admin/benefit_management_portal_code_groups/example"
    >
      <DetailedAlert message="Code Group Import Info" details={details} />
    </ImportModal>
  );
};
